import { render } from "./SectionPortfolioDetailFirst.vue?vue&type=template&id=2bba877e&scoped=true"
import script from "./SectionPortfolioDetailFirst.vue?vue&type=script&lang=js"
export * from "./SectionPortfolioDetailFirst.vue?vue&type=script&lang=js"

import "./SectionPortfolioDetailFirst.vue?vue&type=style&index=0&id=2bba877e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bba877e"]])

export default __exports__